import React from 'react'
import CommonCheckbox from 'common/components/entities/Checkbox'
import { BaseCheckboxInterface } from 'common/types/entities/CheckboxInterface'
import {
  TiptapEditor,
  TiptapEditorUpdatePayload,
} from 'client/components/core/tiptap-editor'
import { useTypography } from 'src/editor/shared/hooks/use-typography'
import { useThemeColor } from 'src/editor/shared/hooks/use-theme-color'
import { useDeviceModeContext } from 'client/context/DeviceModeContext'

export interface BaseEditorCheckboxProps {
  entity: BaseCheckboxInterface
  checked: boolean
  onChange: () => void
  isEditing: boolean
  updateText: (payload: TiptapEditorUpdatePayload) => void
}

export const BaseEditorCheckbox = ({
  entity,
  checked,
  onChange,
  isEditing,
  updateText,
}: BaseEditorCheckboxProps) => {
  const { isMobile } = useDeviceModeContext()
  const {
    text: { paragraphTextColor: globalTextColor },
    links: { linkTextColor: globalLinkColor },
  } = useThemeColor()

  const {
    calculatedFontSize,
    calculatedLineHeight,
    calculatedTextAlign,
    calculatedFontFamily,
    calculatedFontWeight,
    calculatedFontStyle,
  } = useTypography({
    fontSize: entity.fontSize,
    mobileFontSize: entity.mobileFontSize,
    lineHeight: entity.lineHeight,
    mobileLineHeight: entity.mobileLineHeight,
    textAlign: entity.textAlign || 'left',
    mobileTextAlign: entity.mobileTextAlign || 'left',
    fontFamily: entity.fontFamily,
    mobileFontFamily: entity.mobileFontFamily,
    fontWeight: entity.fontWeight,
    mobileFontWeight: entity.mobileFontWeight,
    fontStyle: entity.fontStyle,
    mobileFontStyle: entity.mobileFontStyle,
  })

  return (
    <CommonCheckbox
      entity={entity}
      checked={checked}
      onChangeHandler={onChange}
    >
      <TiptapEditor
        wrapperStyles={{ flexBasis: 'inherit' }} // NOTE: https://app.shortcut.com/systeme/story/71113/checkbox-not-displaying-correctly-on-live-page-it-is-displayed-far-from-the-checkbox-text
        textAlign={calculatedTextAlign.desktop}
        attrId={entity.htmlAttrId}
        editorTextAlign={
          isMobile ? calculatedTextAlign.mobile : calculatedTextAlign.desktop
        }
        isEditing={isEditing}
        content={entity.content || entity.rawContentState || ''}
        update={updateText}
        padding={entity.padding}
        textColor={entity.color || globalTextColor}
        linkColor={globalLinkColor}
        fontSize={calculatedFontSize.desktop}
        fontFamily={calculatedFontFamily.desktop}
        mobileFontFamily={calculatedFontFamily.mobile}
        fontWeight={calculatedFontWeight.desktop}
        lineHeight={calculatedLineHeight.desktop}
        mobilePadding={entity.mobilePadding}
        mobileFontSize={calculatedFontSize.mobile}
        mobileLineHeight={calculatedLineHeight.mobile}
        mobileFontStyle={calculatedFontStyle.mobile}
        mobileFontWeight={calculatedFontWeight.mobile}
      />
    </CommonCheckbox>
  )
}
